// extracted by mini-css-extract-plugin
export default {"base":"Item_base__stg+N"};